export default "__VITE_ASSET__52cb5c8f__"